const KEY = 'authToken'

export const setAuthToken = (authToken) => localStorage.setItem(KEY, authToken)

export const removeAuthToken = () => localStorage.removeItem(KEY)

export const getAuthToken = () => localStorage.getItem(KEY)

export const hasAuthToken = () => Boolean(getAuthToken())

export const getBearerToken = () => {
  const authToken = getAuthToken()
  if (authToken) {
    return `Bearer ${authToken}`
  }
}

export const addAuthorizationHeaderToRequest = (request, next) => {
  const bearerToken = getBearerToken()
  if (bearerToken) {
    request.options.headers = request.options.headers || {}
    request.options.headers.authorization = bearerToken
  }
  if (next) {
    next()
  }
}
